import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { useEffect, useState } from "react";
import { PortfolioService } from "../../../services/portfolio.service";
import { useParams } from "react-router";

interface DetailPage {
  id: number;
  slug: null | string;
  link: string;
  images: string[];
}

const ProjectDetail = () => {
  const { id } = useParams();
  const [project, setProject] = useState<DetailPage | null>(null);

  useEffect(() => {
    async function fetchDetail() {
      const response = await PortfolioService.getAllPortfolioDetail(id);
      if (response.status === 200) {
        setProject(response.data.data);
      }
    }
    fetchDetail();
  }, [id]);

  return (
    <div className="project-section">
      <div className="project-title">Layihələrimiz</div>
      <div className="project-slider-container">
        {project && project.images && project.images.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            className="mySwiper"
          >
            {project.images.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="project-card">
                  <div className="project-image-container">
                    <img src={img} alt={`Image ${index + 1}`} />
                  </div>
                  <button
                    onClick={() => {
                      window.open(project?.link || "https://google.com", "_blank");
                    }}
                    className="project-btn"
                  >
                    {project?.slug || "Mobil tətbiqi yüklə"}
                  </button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="project-card">
            <div className="project-image-container"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectDetail;
